import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React, { useContext } from 'react';

import { AttributeDefinitionsContext } from '../../AttributeDefinitionsContext';

function LogSearchDateFilter() {
  const {
    logsFrom, setlogsFrom, logsTo, setlogsTo,
  } = useContext(AttributeDefinitionsContext);
  const handleDataFormatting = (date) => {
    const valueDate = new Date(date);
    const year = new Date(valueDate).getFullYear();
    const monthValue = new Date(valueDate).getMonth();
    const month = (monthValue + 1) < 10 ? `0${monthValue + 1}` : (monthValue + 1);
    const dayValue = new Date(valueDate).getDate();
    const day = dayValue < 10 ? `0${dayValue}` : dayValue;
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="w-max display:flex, justify-content:center align-items:center">
      <Stack spacing={2}>
        <Typography variant="body2">Date</Typography>
        <div className="flex flex-col sm:flex-row gap-2">
          <Stack spacing={2}>
            <DatePicker
              id="logs-from-date-picker"
              label="From"
              value={logsFrom}
              onChange={(value) => {
                const parsedDate = Date.parse(value);
                if (value === null || (!Number.isNaN(parsedDate) && parsedDate >= Date.parse('1970-01-01'))) {
                  const datefrom = handleDataFormatting(value);
                  setlogsFrom(datefrom);
                } else {
                  setlogsFrom(null);
                }
              }}
              inputFormat="dd-MM-yyyy"
              renderInput={(value) => (
                <TextField
                  {...value}
                  size="small"
                />
              )}
              showDaysOutsideCurrentMonth
              maxDate={logsTo ? new Date(logsTo) : new Date()}
            />
            <DatePicker
              id="logs-to-date-picker"
              label="To"
              value={logsTo}
              onChange={(value) => {
                const parsedDate = Date.parse(value);
                if (value === null || (!Number.isNaN(parsedDate) && parsedDate >= Date.parse('1970-01-01'))) {
                  const dateTo = handleDataFormatting(value);
                  setlogsTo(dateTo);
                } else {
                  setlogsTo(null);
                }
              }}
              inputFormat="dd-MM-yyyy"
              renderInput={(value) => (
                <TextField
                  {...value}
                  size="small"
                />
              )}
              showDaysOutsideCurrentMonth
              minDate={logsFrom && new Date(logsFrom)}
              maxDate={new Date()}
            />
          </Stack>
        </div>
      </Stack>
    </div>
  );
}

export default LogSearchDateFilter;
